import React, { Component } from 'react';
import PropTypesImmutable from 'react-immutable-proptypes';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Col, Collapse, Row } from 'antd';
import { getRole } from '../../reducers/userReducer';
import * as actions from '../../actions/actionCreators/accountGOSListActionCreators';
import { DateField } from '../../atoms';
import { FormActions } from '../../components';
import { links } from '../../utils/gotoLink';
import {
  accountGOSFilterFields,
  FORM_ACCOUNT_GOS_FILTER,
} from '../../constants/formAccountGOSFilter';
import { downloadFileByGetURL } from '../../utils/files';
import dayjs from '../../utils/dayjs';
import FormStateToRedux from '../FormStateToRedux';
import {
  updateFormState,
  formValueSelector,
} from '../../reducers/reactFinalFormReducer';

const { Panel } = Collapse;

export class AccountGOSOverviewFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    filterValues: PropTypesImmutable.map,
    userRole: PropTypes.string.isRequired,
    expirationDateChanged: PropTypes.func.isRequired,
    legalEntityId: PropTypes.any,
    initialValues: PropTypes.object,
    updateFormState: PropTypes.func.isRequired,
    searchAccountGOS: PropTypes.func.isRequired,
  };

  expirationDate = '';

  componentDidMount() {
    const { initialValues, updateFormState } = this.props;
    if (initialValues) {
      this._initialValues = initialValues;
      updateFormState(FORM_ACCOUNT_GOS_FILTER, { values: initialValues });
    }
  }

  updateFilterFields = () => {
    this.expirationDate = this.expirationDateStr;
  };

  expirationDateChange = (date, expirationDateChanged) => {
    if (date) {
      this.expirationDateStr = date;
      expirationDateChanged(date);
    } else {
      this.expirationDateStr = undefined;
      expirationDateChanged(null);
    }
  };

  updateSubmit = () => {
    this.updateFilterFields();
  };

  handleDownloadCSV = () => {
    const expirationDate = this.expirationDate
      ? dayjs(this.expirationDate, 'DD.MM.YYYY HH:mm:ss', true).format(
          'DD.MM.YYYY'
        )
      : null;
    const params = expirationDate ? { expirationDate } : null;
    downloadFileByGetURL(
      links.accountGOSOverviewCsv,
      params,
      'account-overview.csv'
    );
  };

  onSubmit = (values) => {
    this.props.searchAccountGOS(values);
  };

  onClear = (form) => {
    const { updateFormState } = this.props;
    form.restart(this._initialValues);
    updateFormState(FORM_ACCOUNT_GOS_FILTER, { values: this._initialValues });
  };

  render() {
    const { t, expirationDateChanged } = this.props;

    return (
      <React.Fragment>
        <Form
          onSubmit={this.onSubmit}
          initialValues={this._initialValues}
          render={({ handleSubmit, form }) => (
            <Collapse>
              <Panel key="filters" header={t('overview.filter.panelTitle')}>
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux form={FORM_ACCOUNT_GOS_FILTER} />
                  <Row gutter={24}>
                    <Col span={12}>
                      <Field
                        className="date-field"
                        name={accountGOSFilterFields.EXPIRATION_DATE}
                        component={DateField}
                        label={t('overview.filter.expirationDate')}
                        hasFeedback={false}
                        onChange={(date, dateString) => {
                          this.expirationDateChange(
                            dateString,
                            expirationDateChanged
                          );
                        }}
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('overview.filter.clearBtn')}
                    </Button>
                    <Button
                      onClick={() => this.updateSubmit()}
                      type="primary"
                      htmlType="submit"
                    >
                      {t('overview.filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              </Panel>
            </Collapse>
          )}
        />
        <FormActions>
          <Button onClick={this.handleDownloadCSV}>{t('exportCsvBtn')}</Button>
        </FormActions>
      </React.Fragment>
    );
  }
}

const getValues = formValueSelector(FORM_ACCOUNT_GOS_FILTER);

const mapStateToProps = (state) => ({
  filterValues: getValues(state),
  userRole: getRole(state),
});

const mapDispatchToProps = {
  searchAccountGOS: actions.searchAccountGOS,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGOSOverviewFilter);
